import React, { ReactNode } from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import BlankLayout from '../../../../materio/@core/layouts/BlankLayout';

const OAuthStatus = () => {
    const location = useLocation();

    // Utility function to retrieve query parameters from URL
    const getQueryParam = (param: string): string | boolean | null => {
        const params = new URLSearchParams(location.search);
        const value = params.get(param);

        if (value === 'true') return true;
        if (value === 'false') return false;
        return value;
    };

    // Extract necessary query parameters from URL
    const isSuccess = getQueryParam('isSuccess') as boolean | null;
    const title = getQueryParam('title') as string | null;
    const detail = getQueryParam('detail') as string | null;

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor={isSuccess ? 'background.paper' : 'background.default'}
            p={4}
        >
            {isSuccess ? (
                <Alert
                    icon={<CheckCircleOutline fontSize="large" color="primary" />}
                    severity="info"
                    sx={{
                        mb: 3,
                        maxWidth: '500px',
                        backgroundColor: 'rgba(0, 128, 255, 0.05)',
                        border: '1px solid #90caf9',
                    }}
                >
                    <Typography variant="h5" fontWeight="bold">
                        Configuration Complete
                    </Typography>
                    <Typography variant="body1" mt={1}>
                        Your Gmail OAuth configuration was successful. You can now proceed with your application.
                    </Typography>
                </Alert>
            ) : (
                <Alert
                    icon={<ErrorOutline fontSize="large" color="error" />}
                    severity="warning"
                    sx={{
                        mb: 3,
                        maxWidth: '500px',
                        backgroundColor: 'rgba(255, 0, 0, 0.05)',
                        border: '1px solid #ef9a9a',
                    }}
                >
                    <Typography variant="h5" fontWeight="bold">
                        {title || 'Error Occurred'}
                    </Typography>
                    <Typography variant="body1" mt={1}>
                        {detail || 'An issue occurred while completing the OAuth configuration. Please try again.'}
                    </Typography>
                </Alert>
            )}
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3, textAlign: 'center' }}>
                You can now close this window.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => window.close()} sx={{ mt: 2 }}>
                Close Window
            </Button>
        </Box>
    );
};

OAuthStatus.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>;
OAuthStatus.guestGuard = false;

export default OAuthStatus;
